module.exports = __webpack_public_path__ + "static/img/img28.dc23210.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img28.png
// module id = m+/X
// module chunks = 1